import PropTypes from "prop-types";

function AdmMobile({ app, config }) {
  return <></>;
}

AdmMobile.defaultProps = {
  app: null,
  config: {},
};

AdmMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default AdmMobile;
